import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_HOMEPAGE_SUCCESS = "SHOP:UPSERT_HOMEPAGE_SUCCESS";

export const upsertHomepageSuccessAction = (
  organization: OrganizationKeyName,
  id?: string
) => ({
  type: UPSERT_HOMEPAGE_SUCCESS as typeof UPSERT_HOMEPAGE_SUCCESS,
  organization,
  id,
});

export type UpsertHomepageSuccessAction = ReturnType<
  typeof upsertHomepageSuccessAction
>;
